"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_deals__or__partnership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "33f35392-90a5-4e5d-a486-7efbeb16c408",
    "data-name": "deal-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b77ec8db-ad02-4fb5-b024-8868bb28df23",
    x1: 78.78,
    y1: 70.54,
    x2: 152.12,
    y2: 143.88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "3bce195c-ec43-4422-bda4-738e90cfa540",
    x1: 48.75,
    y1: 97.48,
    x2: 49.67,
    y2: 98.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#666",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "deal-hi"), /*#__PURE__*/React.createElement("g", {
    id: "a60ac9ec-ff76-4dd3-a3db-f2eb0f83c989",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24d4599e-0c5a-4e4f-b2d7-0474bfa2677e",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "80daa83f-3490-4efc-8aa1-dd6c1ab3021c",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9ab64935-cb48-43be-a033-c5dee3391066",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28a5891c-8652-4374-8431-fb64814fde7a",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a9298712-adfb-402f-a057-332845736610",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e6b5919a-6819-4449-8e48-1e48a71b921c",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "23182ce8-67c4-4bff-b69b-035a3b91e6eb",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0b030ade-b343-45b3-a5a1-d60d62fcfdc2",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "55001b78-f213-4550-be17-cabac3d6bade",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ee85a3b8-c461-4929-9350-f18a5b4a7451",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f685c8d5-d6e2-44f7-9066-711361c0892d",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2bc3c78-2934-453f-aa54-493600c54e71",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "baddb341-9cc3-4773-8c71-d45b154024cc",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cda55709-a354-4392-afe2-4f9a1e1854e9",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d0704dfa-20fb-4980-a201-32495473c02d",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "814bc900-bce5-4993-925c-7dd65df28a96",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0a8ae050-72cd-4adc-9476-65c44ecb0b7d",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "53df22f0-53cc-423a-a50b-e52b63dbf584",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c70d280c-04e9-4faf-bf0c-6cdd2d555cf4",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7d182df7-0ffd-4a5c-81a3-a427c4c0ba81",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "884d27bc-1850-49ba-9d14-f68ec55afa17",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d037f9a2-a76c-4d71-bb9c-812558202161",
    "data-name": "SoHo_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24b7260e-9213-443b-8b0a-811aeb0c076f",
    "data-name": "SME_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e669cc56-ef4c-4267-8a7d-dedd3132727b",
    "data-name": "Public_sector_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d34b1718-4305-46ae-ba5d-b265bd541712",
    "data-name": "Extras_services_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9e2ee2d3-4df6-4cbc-90fe-45f5a8caa7b6",
    "data-name": "Deal_Partnership_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.7,102.24,90.86,34.63l-1.33-.77a43.16,43.16,0,0,0-59,15.8l-9.79,17a43.16,43.16,0,0,0,15.8,59l67.82,39.16a13.7,13.7,0,0,0,6.87,1.85,13.87,13.87,0,0,0,3.59-.48A13.73,13.73,0,0,0,125,153.75a13.77,13.77,0,0,0,18.28-12.06,13.79,13.79,0,0,0,17.84-16.59l0-.05a13.78,13.78,0,0,0,9.84-16.9C170.38,105.89,167.7,102.24,167.7,102.24Z",
    transform: "translate(0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,147.62a13.72,13.72,0,0,0,1.81-5.93,13.79,13.79,0,0,0,17.84-16.59l0-.05a13.78,13.78,0,0,0,9.84-16.9c-.6-2.24-3.28-5.89-3.28-5.89h0L121.22,75.41a23.4,23.4,0,0,1-6.52,5.16c-6.43,3.3-14.3,5.56-24.68,2L80,93.42c-6.25,6.23-19.82,9.68-25.57,7.52l-3.2-1.2a4,4,0,0,1-1.06-.59l66.38,66.38a13.69,13.69,0,0,0,8.5-11.78,13.79,13.79,0,0,0,16.47-6.13Z",
    transform: "translate(0)",
    opacity: 0.2,
    fill: "url(#b77ec8db-ad02-4fb5-b024-8868bb28df23)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.88,97.36l-.25.25.92.92A4,4,0,0,1,48.88,97.36Z",
    transform: "translate(0)",
    fill: "url(#3bce195c-ec43-4422-bda4-738e90cfa540)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.22,75.41l46.47,26.83a42.87,42.87,0,0,0,3.53-33,44.19,44.19,0,0,0-20.49-25.51l-16.26-9.39A43.19,43.19,0,0,0,75.54,50.1L49.26,93.84a4.18,4.18,0,0,0-.64,2,4,4,0,0,0,2.6,3.89l3.2,1.2c5.75,2.16,19.33-1.29,25.57-7.52L90,82.55c10.37,3.58,18.25,1.33,24.68-2A23.4,23.4,0,0,0,121.22,75.41Z",
    transform: "translate(0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.68,100.24,121.22,73.41a23.4,23.4,0,0,1-6.52,5.16c-6.43,3.3-14.3,5.56-24.68,2L80,91.42c-6.25,6.23-19.82,9.68-25.57,7.52l-3.2-1.2A4,4,0,0,1,48.76,95a3.62,3.62,0,0,0-.14.85,4,4,0,0,0,2.6,3.9l3.2,1.2c5.75,2.16,19.33-1.29,25.57-7.52L90,82.55c10.37,3.58,18.25,1.33,24.68-2a23.4,23.4,0,0,0,6.52-5.16l46.47,26.83A42.87,42.87,0,0,0,173,80.6,42.92,42.92,0,0,1,167.68,100.24Z",
    transform: "translate(0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.78,133.56a13.79,13.79,0,0,1-16.46,6.13h0a13.78,13.78,0,0,1-2.37-1.08L98.55,114.13c-1-.55-1.58,1.09,0,2l42.39,24.47a13.83,13.83,0,0,0,2.1,1,13.65,13.65,0,0,1-1.53,4A13.79,13.79,0,0,1,125,151.75v0a13.8,13.8,0,0,1-2.37-1.08L88.77,131.09c-1-.55-1.58,1.09,0,2l33.91,19.58a13.85,13.85,0,0,0,2.09,1,13.54,13.54,0,0,1-1.52,4,13.7,13.7,0,0,1-8.37,6.43,13.87,13.87,0,0,1-3.59.48,13.7,13.7,0,0,1-6.87-1.85L36.59,123.57A42.87,42.87,0,0,1,16.48,97.36,43.45,43.45,0,0,1,15,87.16a43.32,43.32,0,0,0,1.47,12.2,42.87,42.87,0,0,0,20.11,26.21l67.82,39.16a13.7,13.7,0,0,0,6.87,1.85,13.87,13.87,0,0,0,3.59-.48,13.77,13.77,0,0,0,10.18-12.35,13.79,13.79,0,0,0,18.27-12.06,13.78,13.78,0,0,0,18.26-14.07A13.72,13.72,0,0,1,159.78,133.56Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.41,110.67a13.79,13.79,0,0,1-20.64,11L108.35,97.17c-1-.55-1.58,1.09,0,2l42.42,24.47a13.79,13.79,0,0,0,20.64-13Z",
    transform: "translate(0)"
  }))))))))))))))))))))))))))))));
}

var _default = ic_deals__or__partnership;
exports.default = _default;